require('./externalTransferFundStep3.scss');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const RadioButtonTableFunds = require('./radioButtonTableFunds.js');
const BrokerMiFIDUSPersonModal = require('mifid/components/brokerMiFIDUSPersonModal/brokerMiFIDUSPersonModal');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const {
    HYPHEN,
    THIRD_STEP
} = require('constants/index');
// @ helpers
const { getLastNChars } = require('utilities/stringHelper');

class ExternalTransferFundStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSetDestinationFundChange = this.handleSetDestinationFundChange.bind(this);
    }

    componentDidMount() {
        const { immExternalTransferFund } = this.props;
        const isin = immExternalTransferFund.getIn(['steps', 1, 'instrumentId']);
        this.props.getOriginFund(isin);
        this.props.onResetMifid();
    }

    handleSetDestinationFundChange(fundId) {
        const { getInterveners, setDestinationFund, immBrokerMyInvestments, history } = this.props;
        const immFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === fundId );
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        if (linkedToRobo) {
            this.setState({
                showModal: true,
            });
        }
        setDestinationFund(fundId, linkedToRobo);
        getInterveners(history, fundId);
    }

    handleCloseModal() {
        this.setState ({
            showModal: false,
        });
    }

    buildModalWarning() {
        const modalText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalDescription');
        const modalButtonText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalButtonText');
        return (
            <OKModal
                description={modalText}
                isOpen={this.state.showModal}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleCloseModal}
                footerType="action"
                primaryButtonText={modalButtonText}
            />
        );
    }

    buildAccountDetails() {
        const { immExternalTransferFund, immAccounts } = this.props;
        const fundId = immExternalTransferFund.getIn(['steps', 2, 'destinationFund']);
        const fundAccount = immExternalTransferFund.getIn(['funds', 'byId', fundId, 'account']);

        if (fundAccount) {
            const immAccount = immAccounts
                .get('byId')
                .find(
                    account =>
                        account.get('product') === fundAccount.get('product') &&
                        account.get('contractNumber') === fundAccount.get('contractNumber')
                );
            const injectedStrings = [
                immAccount.get('accountHolder'),
                immAccount.get('interventionType'),
                immAccount.get('alias'),
                getLastNChars(immAccount.get('iban'))
            ];

            return (
                <div className="external-transfer-fund-step3__fund-details">
                    <FormattedText
                        value="brokerExternalTransferFundStep3-infoText"
                        injectedStrings={injectedStrings}
                    />
                </div>
            );
        }
    }

    buildDestinationFundContainer() {
        const { immExternalTransferFund, immBrokerMyInvestments } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products','funds','stocks']).map(destinationFund => {
            return destinationFund.get('totalValue') == null ? destinationFund.set('totalValue', HYPHEN) : destinationFund;
        });
        const fundId = immExternalTransferFund.getIn(['steps', 2, 'destinationFund']);
        return (
            <RadioButtonTableFunds
                immFunds={immFunds}
                currentFundId={fundId}
                onFundChange={this.handleSetDestinationFundChange}
            />
        )
    }

    buildFundsIndexes() {
        const { immBrokerMyInvestments } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).toJS();
        let indexArray = [];
        immFunds.forEach(fund => {
            indexArray.push(fund.id);
        });
        return indexArray;
    }

    buildMifidModal() {
        const { immExternalTransferFund, immBrokerMyInvestments } = this.props;

        if (immExternalTransferFund.get('mustRunMifid')) {
            const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
            const destinationFundId = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'destinationFund']);
            const immDestinationFund = immFunds.find(immFund => immFund.get('id') == destinationFundId);

            const destinationFundIsin =
                immDestinationFund ?
                immDestinationFund.get('isin') :
                '';

            return (
                <BrokerMiFIDUSPersonModal
                    onContinueOperation={this.props.onStartMifid}
                    onCancel={this.props.onCancelMifid}
                    isinId={destinationFundIsin}
                />
            );
        }
    }

    buildFundSelectedInfo() {
        const { immExternalTransferFund } = this.props;
        const immInterveners = immExternalTransferFund.getIn(['interveners','byId']).toIndexedSeq().toArray();
        const title = formatText("brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_fundInfoTitle");
        const nameLabel = formatText("brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_fundInfoNameLabel");
        const typeLabel = formatText("brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_fundInfoTypeLabel");
        const intervenersRows = immInterveners.map((immIntervener, index) => {
            const type = formatText(`interventionTypes-${immIntervener.get('desintervencion')}`);
            const name = immIntervener.get('nombre').toUpperCase();
            return (
                <div className="row external-transfer-fund-step3-fund-info__row" key={index}>
                    <div className="col-xs-6 external-transfer-fund-step3-fund-info__field">
                        {name}
                    </div>
                    <div className="col-xs-6 external-transfer-fund-step3-fund-info__field">
                        {type}
                    </div>
                </div>
            );
        });
        return immExternalTransferFund.get('isFetchingInteveners') ? <LoadingSection/> : (
            <div>
                <div className="external-transfer-fund-step3-fund-info__title">
                    {title}
                </div>
                <div className="row">
                    <div className="col-xs-6 external-transfer-fund-step3-fund-info__subtitle">
                        {nameLabel}
                    </div>
                    <div className="col-xs-6 external-transfer-fund-step3-fund-info__subtitle">
                        {typeLabel}
                    </div>
                </div>
                {intervenersRows}
            </div>
        );
    }

    render() {
        const { immExternalTransferFund } = this.props;
        const destinationFundValid = immExternalTransferFund.get('interveners');
        const fundContainer = this.buildDestinationFundContainer();
        const accountDetails = this.buildAccountDetails();
        const mifidModal = this.buildMifidModal();
        const modalWarning = this.buildModalWarning();
        const fundSelectedInfo = destinationFundValid ? this.buildFundSelectedInfo() : null;
        return (
            <React.Fragment>
                <div className="external-transfer-fund-step3">
                    {mifidModal}
                    {modalWarning}
                    <FormattedText
                        value="brokerExternalTransferFundStep3-title"
                        className="external-transfer-fund-step3__title"
                />
                    <FormattedText
                        value="brokerExternalTransferFundStep3-subtitle"
                        className="external-transfer-fund-step3__subtitle"
                />
                    <FormattedText
                        value="brokerExternalTransferFundStep3-destinationFund"
                        className="external-transfer-fund-step3__destination-fund"
                />
                    <div  className="external-transfer-fund-step3__disclaimer">
                        <OKMessage type="important">
                            <FormattedText
                                value="brokerExternalTransferFundStep3-warning"
                                className="external-transfer-fund-step3__warning"
                        />
                        </OKMessage>
                    </div>
                    <div className="external-transfer-fund-step3__fund-div">
                        {fundContainer}
                        {accountDetails}
                    </div>
                    {fundSelectedInfo}
                </div>
            </React.Fragment>

        );
    }
}

ExternalTransferFundStep3.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immExternalTransferFund: PropTypes.object.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    getOriginFund: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    onStartMifid: PropTypes.func.isRequired,
    onCancelMifid: PropTypes.func.isRequired,
    onResetMifid: PropTypes.func.isRequired
};

module.exports = withRouter(ExternalTransferFundStep3);
